import { useGeneralProposalDetailVM } from "presentation/hook/GeneralProposal/useGeneralProposalDetailVM";
import { useGeneralProposalDetailTracked } from "presentation/store/GeneralProposal/GeneralProposalDetailProvider";
import { memo, useCallback, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import { AddTariffItemIsEditPanel } from "./Right/AddTariffItemIsEditPanel";
import GeneralProposalDetailTablePanel from "./Table/GeneralProposalDetailTablePanel";
import { useGeneralProposalTracked } from "presentation/store/GeneralProposal/GeneralProposalProvider";
import { useGeneralProposalVM } from "presentation/hook/GeneralProposal/useGeneralProposalVM";

const GeneralProposalDetailMaintenance: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const generalProposalDtlVM = useGeneralProposalDetailVM();
    const gengenProposalVM = useGeneralProposalVM();
    const [generalProposalDetailState] = useGeneralProposalDetailTracked();
    const [genProposalState] = useGeneralProposalTracked();

    const initialScreen = useCallback(async () => {
        setIsLoading(true);
        try {
            const results = await Promise.allSettled([
                generalProposalDtlVM.onPageInit(),
                generalProposalDtlVM.loadDropdownOption(),
                gengenProposalVM.searchGeneralProposalItem(genProposalState.currentSelectedRow)
            ]);
            results?.forEach((result, index) => {
                if (index === 0 && result.status === 'fulfilled') {

                } else if (index === 1 && result.status === 'rejected') {

                }
            });
            setIsLoading(false);
        } catch (error) {
        }
    }, [genProposalState.currentSelectedRow, generalProposalDtlVM, gengenProposalVM]);

    useEffect(() => {
        initialScreen();
    }, [initialScreen])


    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;
    return <>
        <div className={`main-comp-wrapper${(generalProposalDetailState.isShowEditPanel) ? '' : ' im-hide-side-form-draggable'}`}>
            {/* <GeneralProposalDetailTitleBar /> */}
            <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={generalProposalDetailState.isShowEditPanel ? "60%" : "100%"}
                rightSectionWidth={generalProposalDetailState.isShowEditPanel ? "40%" : "0%"}
                leftChildren={<GeneralProposalDetailTablePanel />}
                rightChildren={<AddTariffItemIsEditPanel />}
            />
        </div>
    </>
}

export default memo(GeneralProposalDetailMaintenance);